import React, { useEffect, useState } from "react";
import { Swords, Trophy, TrendingUp } from "lucide-react";
import AppLayout from "@/components/AppLayout";
import api from "@/lib/api";

const rm = (n) => "RM " + (n || 0).toLocaleString("en-MY");

export default function Battle() {
  const [data, setData] = useState(null);
  const [clock, setClock] = useState(523);
  useEffect(() => { api.get("/battle").then((r) => setData(r.data)); const i = setInterval(() => setClock((c) => (c > 0 ? c - 1 : 0)), 1000); return () => clearInterval(i); }, []);
  if (!data) return <AppLayout active="battle"><div className="animate-pulse text-muted-foreground font-mono">Loading battle…</div></AppLayout>;

  const total = Math.max(1, data.team_a.revenue + data.team_b.revenue);
  const aPct = Math.round((data.team_a.revenue / total) * 100);
  const fmt = (s) => `${String(Math.floor(s / 60)).padStart(2, "0")}:${String(s % 60).padStart(2, "0")}`;

  return (
    <AppLayout active="battle">
      <div className="text-center mb-8">
        <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-[#E5253A]/10 text-[#E5253A] text-xs font-bold mb-3"><Swords className="h-4 w-4" /> 🔥 LIVE BATTLE</div>
        <div className="text-4xl font-mono font-extrabold" data-testid="battle-clock">{fmt(clock)}</div>
        <p className="text-xs text-muted-foreground mt-1">Revenue from real transactions & CRM — not manual score.</p>
      </div>

      <div className="grid md:grid-cols-2 gap-4">
        {[["a", data.team_a, "cyan"], ["b", data.team_b, "amber"]].map(([k, tm, color]) => (
          <div key={k} data-testid={`team-${k}`} className={`rounded-2xl border p-6 ${k === "a" ? "border-cyan-500/40 bg-cyan-500/5" : "border-amber-500/40 bg-amber-500/5"}`}>
            <div className="flex items-center justify-between">
              <div className="text-lg font-bold tracking-tight">{tm.name}</div>
              <div className="text-xs text-muted-foreground">{tm.host}</div>
            </div>
            <div className={`mt-4 text-3xl font-mono font-extrabold ${k === "a" ? "text-cyan-400" : "text-amber-400"}`}>{rm(tm.revenue)}</div>
            <div className="mt-4 grid grid-cols-2 gap-3 text-center">
              <div className="rounded-lg bg-card border border-border p-3"><div className="font-mono font-bold">{tm.leads}</div><div className="text-[10px] text-muted-foreground">Leads</div></div>
              <div className="rounded-lg bg-card border border-border p-3"><div className="font-mono font-bold">{tm.sales}</div><div className="text-[10px] text-muted-foreground">Sales</div></div>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-6 rounded-xl border border-border bg-card p-5">
        <div className="flex items-center justify-between text-xs font-mono mb-2"><span className="text-cyan-400">{data.team_a.name} {aPct}%</span><span className="text-amber-400">{100 - aPct}% {data.team_b.name}</span></div>
        <div className="h-4 rounded-full bg-amber-500/30 overflow-hidden flex"><div className="h-full bg-cyan-500 transition-all" style={{ width: `${aPct}%` }} /></div>
      </div>

      <div className="mt-6 rounded-xl border border-border bg-card p-5">
        <h3 className="font-bold flex items-center gap-2 mb-4"><Trophy className="h-4 w-4 text-amber-400" /> MVP Host Leaderboard</h3>
        <div className="space-y-2">
          {data.leaderboard.map((h, i) => (
            <div key={h.host} className="flex items-center justify-between rounded-lg border border-border px-4 py-2.5">
              <div className="flex items-center gap-3"><span className={`h-6 w-6 rounded-full flex items-center justify-center text-xs font-bold font-mono ${i === 0 ? "bg-amber-500/20 text-amber-400" : "bg-accent text-muted-foreground"}`}>{i + 1}</span><span className="text-sm font-medium">{h.host}</span></div>
              <span className="text-sm font-mono font-bold text-emerald-400 flex items-center gap-1"><TrendingUp className="h-3.5 w-3.5" /> {rm(h.revenue)}</span>
            </div>
          ))}
        </div>
      </div>
    </AppLayout>
  );
}
